import enTZ from '../i18n/en-TZ';
import swTZ from '../i18n/sw-TZ';

import LocalDB from '../utils/localDB';

const activeLocale = 'enTZ' || LocalDB.fetch('locale').code

const locales = [
    { code: 'enTZ', name: 'English' },
    { code: 'swTZ', name: 'Kiswahili' }
]

const setLocale = (locale) => {
    console.log('Active Locale:', locale.name);
    LocalDB.insert('locale', locale);
}

const _getTranslations = () => {
    var translations = enTZ
    
    switch(activeLocale){
        
        case 'swTZ':
            translations = swTZ
            break;

        case 'enTZ':
            translations = enTZ
            break;
        
        default:
            break;
    }

    return translations;
}

const translations = _getTranslations()

export { locales, translations, setLocale }


// WEBPACK FOOTER //
// ./src/i18n/translations.js